import React, { useContext } from "react";
import "./PageSeven.scss";
import { BuildingsContext } from "../../../bContext";

function PageSeven() {
  const { switchToEnglish} = useContext(
    BuildingsContext
  );
  return (
    <>
    <div className="pageSeven">
      <div className="speech-bubble4">
      {switchToEnglish === false ? 
        <p className="first">
          Wszystkie obiekty, uczestniczące w procesie oczyszczania ścieków , możemy zobaczyć w szczegółowym opisie, aby tego dokonać, wystarczy najechać na jeden z nich kursorem myszki, podświetli się na niebiesko...
        </p>
        :
        <p className="first">
        All the facilities involved in the wastewater treatment process can be seen in a detailed description, in order to do so it is enough to hover over one of them with the mouse cursor...
      </p>
      }
        <div className="inner-triangle-right4"></div>
      </div>
       <div className="menu-pg4"></div> 

      <div>
      <div className="speech-bubble5">
      {switchToEnglish === false ? 
        <p className="first">
         Na planszy widzimy kilkanaście budynków połączonych kolorowymi liniami. Linie pokazują kierunki przepływu ścieków oraz osadów.
        </p>
        :
        <p className="first">
        On the board we can see a dozen or so buildings connected by colorful lines. The lines show the flow directions of sewage and sediments
        </p>
      }
      </div>
      
        <div className="modal-header-ins"></div>
        <div className="modalbtn"></div>
        <div className="defaultbtn"></div>
      </div>
    </div>      
    </>
  );
}

export default PageSeven;
